import React from 'react';
import { Visibility } from '@mui/icons-material';
import type {
  DimensionsCollection,
  PanelDimensionalScores,
} from '../../../../../graphql';
import { IconButton } from '../../../../../../../components';
import {
  DIMENSION_TYPE,
  SYSTEM_SCORE,
} from '../../../../../../Nomination/components';
import { getDepartmentRating, isOverrideVersion } from '../panelDataHandling';

type ProcessPanelDimensionalScores = {
  dimension: string;
  displayScore: number;
  systemScore: number;
  isOverrideVersion: boolean;
  hasRemark: boolean;
};

export const processPanelDimensionalScores = (
  scoringSystem: SYSTEM_SCORE,
  panelDimensionalScores: PanelDimensionalScores[],
  dimensionsCollection: DimensionsCollection[],
): ProcessPanelDimensionalScores[] => {
  const defaultDimensionScoreMap: Record<
    SYSTEM_SCORE,
    Array<{ label: string; value: number }>
  > = {
    [SYSTEM_SCORE.HKPFS]: [
      { label: DIMENSION_TYPE.AE, value: 0 },
      { label: DIMENSION_TYPE.RP, value: 0 },
      { label: DIMENSION_TYPE.US, value: 0 },
      { label: DIMENSION_TYPE.CD, value: 0 },
      { label: DIMENSION_TYPE.LS, value: 0 },
      { label: DIMENSION_TYPE.CI, value: 0 },
    ],
    [SYSTEM_SCORE.UPAF]: [
      { label: DIMENSION_TYPE.AE, value: 0 },
      { label: DIMENSION_TYPE.RP, value: 0 },
      { label: DIMENSION_TYPE.LS, value: 0 },
      { label: DIMENSION_TYPE.CI, value: 0 },
      { label: DIMENSION_TYPE.RE, value: 0 },
      { label: DIMENSION_TYPE.OS, value: 0 },
      { label: DIMENSION_TYPE.CD, value: 0 },
      { label: DIMENSION_TYPE.US, value: 0 },
    ],
  };

  const filteredPanelDimensionalScores = (panelDimensionalScores ?? [])?.filter(
    dm => dm.scoringSystem === scoringSystem,
  );
  return defaultDimensionScoreMap[scoringSystem].map(dm => {
    const { label, value } = dm;
    const matchedScores = filteredPanelDimensionalScores.find(
      dm => dm.dimension === label,
    );

    const dimensionFullName =
      dimensionsCollection.find(dm => dm.abbv === label)?.dimensionName ?? '';

    const isOverride = isOverrideVersion(
      matchedScores?.systemScore,
      matchedScores?.overrideScore,
    );
    const departmentRating = getDepartmentRating(
      matchedScores?.systemScore,
      matchedScores?.overrideScore,
      value,
    );
    return {
      dimension: dimensionFullName,
      displayScore: departmentRating,
      systemScore: matchedScores?.systemScore ?? 0,
      isOverrideVersion: isOverride,
      hasRemark: Boolean(matchedScores?.remark),
    };
  });
};

export const moreBox = (applicationId: string): React.ReactNode => {
  return (
    <div>
      <IconButton
        onClick={() => {
          window.open(`/internal/monitor/${applicationId}`);
        }}
        color="primary"
        size="large"
        icon={<Visibility />}
      />
    </div>
  );
};
